<template>
    <div class="question_checkbox">
        <el-popover placement="left-end" :title="data.question" width="500" trigger="hover">
            <!-- <blockquote>一、每月需要配合我公司会计的事项<br>1、票据传递<br>（1）
                每月25日至次月5日期间，请贵公司将银行回单、银行对账单（电子版）、工资表及社保明细表、进项发票及认证清单（小规模企业无认证清单，但是请您提供成本发票）、销项发票及发票汇总表、开票明细表、费用发票等票据整理好，一起交付给专属会计，以便会计能够及时完成账务处理和纳税申报工作。账务处理是否及时，取决于贵公司的票据交付时间，希望贵公司调整时间尽早交付相关票据。<br>（2）贵公司提供以上票据时，请复核开票清单中的明细是否与销项发票相符；认证清单中的明细是否与进项发票相符；银行对账单中的明细是否与银行回单相符；从而减少因票据短缺，二次传递票据耽误的时间，避免因票据缺失，造成的税务风险问题。<br>（3）贵公司人员/联系电话发生变化时，请及时提供最新联系号码，便于我们及时沟通；当社保、公积金人员发生变更时，请及时通知会计进行增减员操作。<br>2、票据注意事项<br>（1）发票抬头必须打印公司全称及税号（18位）方可入账；<br>（2）个人名称抬头的发票不可入账，除火车票、飞机票、电话费发票之外；火车票、飞机票、电话费发票人员，必须为工资表中的人员才可以在本公司报销，否则不可使用；<br>（3）办公费发票需要附明细清单入账；<br>（4）公司名下无车，汽车保险费、保养费、车船税不可入账，维修费、过路过桥费及汽车油费的报销，需要签订《租车协议》后，方可入账；<br>（5）业务招待费（餐饮票）按税法扣除标准为全年收入总额的0.5%，招待费入账太多，需要按比例调增缴纳企业所得税。外地餐费报销需要填制《差旅费报销单》，附件中要有相应的飞机票、火车票、长途汽车票或租车发票等证明资料；<br>（6）大额票据应通过银行转账支付，现金付款的风险较大，容易被税务预警稽查；<br>（7）上述票据均需每月5日之前提供给会计，以供会计进行账务处理、纳税申报。正常申报期是每月15日前进行上月的纳税申报（比如12月份申报11月份的，费用发票日期则需是11月或之前月份的，跨年度的票据不能入账）。<br>3、税款确认<br>会计在每月25日左右，第一次与您确认需扣税的大概金额，在每月纳税申报期，会将具体账务处理后应缴纳的各项税费金额通过专属会计服务群告知您，请及时关注群信息并确认，及时存入对公账户，便于我公司会计及时申报扣税，避免因扣税不及时产生的额外费用。<br>4、三项对账<br>会计在每月纳税申报后，将账务中现金，银行余额、往来余额、库存余额等数据在群内告知贵公司，希望贵公司认真核对并及时与会计进行沟通确认<br>
            </blockquote> -->
            <div v-html="data.remark"></div>
            <div slot="reference" class="question_checkbox-title">{{index}}.{{data.question}}<i class="bqh bqh-icon--help"></i></div>
        </el-popover>
        <template v-if="data.optionType==0">
            <el-radio-group :value="value" @input="input">
                <el-radio v-for="(item,i) in data.option.split(',')" :key="i" :label="item" />
            </el-radio-group>
        </template>
        <template v-if="data.optionType==1">
            <el-checkbox-group :value="value" @input="input">
                <el-checkbox v-for="(item,i) in data.option.split(',')" :key="i" :label="item" />
            </el-checkbox-group>
        </template>
    </div>
</template>

<script>
export default {
    name: 'questionCheckbox',
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            type: String,
            default: () => '',
        },
        index: {
            type: Number,
            default: () => 1,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        input(value) {
            this.$emit('change', value)
        },
    },
}
</script>

<style lang="scss" scoped>
.question_checkbox {
    margin: 6px 0 4px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
    &-title {
        margin: 16px 0;
    }
    .bqh-icon--help{
        cursor:help;
        display: inline-block;
        text-align: center;
        color: #409eff;
        font-size: 13px;
    }
}
</style>
